import styled from 'styled-components';

export default styled.div`
  display: flex;
  gap: 15px;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;
`;
